import { render, staticRenderFns } from "./SendForgotPasswordEmailPopup.vue?vue&type=template&id=6bab2e96&scoped=true&"
import script from "./SendForgotPasswordEmailPopup.vue?vue&type=script&lang=js&"
export * from "./SendForgotPasswordEmailPopup.vue?vue&type=script&lang=js&"
import style0 from "./SendForgotPasswordEmailPopup.vue?vue&type=style&index=0&id=6bab2e96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bab2e96",
  null
  
)

export default component.exports